import { Box } from 'styled-system/jsx';

export function Skeleton({
  width = '100%',
  height = '16px',
  borderRadius = '8px',
  backgroundColor = '#e5e7eb',
  circle = false,
}) {
  return (
    <Box
      width={width}
      height={height}
      borderRadius={circle ? '50%' : borderRadius}
      background={backgroundColor}
      position="relative"
      overflow="hidden"
    >
      <Box
        position="absolute"
        inset="0"
        background="linear-gradient(90deg, transparent, rgba(165, 165, 165, 0.6), transparent)"
        backgroundSize="200% 100%"
        animation="skeleton-loading 1.5s infinite linear"
      />
    </Box>
  );
}
